import React from "react";
import PropTypes from "prop-types";
import { renderStars } from "../../helpers/reviewHelper";

const RatingsDisplay = ({ review }) => {
    if (!review) return null;

    const ratings = {
        Overall: review.overallRating,
        Durability: review.durabilityRating,
        Comfort: review.comfortRating,
        Functionality: review.functionalityRating,
        Value: review.valueRating,
    };

    return (
        <div className="cart-side-notes">
            {Object.entries(ratings).map(([label, value]) =>
                value !== undefined && value !== null ? ( 
                    <div key={label} className="overall-rating-list">
                        <label className="cart-side-label">{label}:</label>
                        <div>
                            {renderStars(value)} &nbsp; {value}
                        </div>
                    </div>
                ) : null
            )}
        </div>
    );
};

RatingsDisplay.propTypes = {
    review: PropTypes.shape({
        overallRating: PropTypes.number,
        durabilityRating: PropTypes.number,
        comfortRating: PropTypes.number,
        functionalityRating: PropTypes.number,
        valueRating: PropTypes.number,
    }).isRequired,
};

export default RatingsDisplay;
